const usuario = JSON.parse(localStorage.getItem('user'));

 export const menuItems = 
 
 usuario.role == 1 ? [
  {
    id: 1,
    label: "menuitems.menu.text",
    isTitle: true,
  },
  {
    id: 2,
    label: "menuitems.dashboards.text",
    icon: "bx-home-circle",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.dashboards.badge",
    // },
    subItems: [
      {
        id: 3,
        label: "menuitems.dashboards.list.principal",
        link: "/",
        parentId: 2,
      },
    ],
  },
  {
    id: 7,
    isLayout: true,
  },
  {
    id: 8,
    label: "menuitems.apps.text",
    isTitle: true,
  },

   // Productos
   {
    id: 122,
    label: "menuitems.productos.text",
    icon: "bx bxl-dropbox",
    
    subItems: [
      {
        id: 15,
        label: "menuitems.inventario.list.concentrado",
        link: "/inventario/concentrado",
        parentId: 12
      }, 
      {
        id: 15,
        label: "menuitems.inventario.list.medicina",
        link: "/inventario/medicina",
        parentId: 12
      }, 
    ],
  },
    // CERDOS
    {
      id: 400,
      label: "menuitems.cerdos.text",
      icon: "bx-store",
  
      subItems: [
        {
          id: 15,
          label: "menuitems.cerdos.list.tipo_animal",
          link: "/tipo_animal/tipo_animal",
          parentId: 400
        }, 
        {
          id: 16,
          label: "menuitems.cerdos.list.cerdos",
          link: "/cerdos/cerdos",
          parentId: 400
        }, 
        {
          id: 17,
          label: "menuitems.cerdos.list.lotes",
          link: "/cerdos/lotes",
          parentId: 400
        }, 
        {
          id: 18,
          label: "menuitems.cerdos.list.asignacion_corrales",
          link: "/cerdos/asignacion_corrales/:page_a/:lote_a",
          parentId: 400
        }, 
  
      ],
    },
    // Ciclo reproductivo
    {
      id: 1403,
      label: "menuitems.ciclo-reproductivo.text",
      icon: "bx-sync",
      
      subItems: [
      
        {
          id: 19,
          label: "menuitems.cerdos.list.inseminacion",
          link: "/cerdos/inseminacion",
          parentId: 400
        }, 
        {
          id: 43453,
          label: "menuitems.cerdos.list.traslado",
          link: "/cerdos/traslado",
          parentId: 400
        }, 
  
      ],
    },
      // Asignacion de alimentos
   {
    id: 1000,
    label: "menuitems.alimento.text",
    icon: "bx bxl-dropbox",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.alimento.badge",
    // },
    subItems: [
      {
        id: 1001,
        label: "menuitems.alimento.list.alimento",
        link: "/alimento/AsignacionAlimento",
        parentId: 1000
      }, 
      {
        id: 1002,
        label: "menuitems.alimento.list.listado_lotes_alimento",
        link: "/alimento/listado_lotes_alimento",
        parentId: 1000
      }, 
   
    ],
  },
  //Compras
  {
    id: 34,
    label: "menuitems.compras.principal",
    icon: "bx bx-shopping-bag",
    subItems: [
      {
        id: 35,
        label: "menuitems.compras.list.proveedor",
        link: "/compras/proveedor",
        parentId: 28,
      },

      {
        id: 37,
        label: "menuitems.compras.list.compras",
        link: "/compras/compras",
        parentId: 29,
      },
      {
        id: 37,
        label: "menuitems.compras.list.compras_medicina",
        link: "/compras/compras_medicina",
        parentId: 29,
      },
      {
        id: 1203,
        label: "menuitems.compras.list.compras_cerdos",
        link: "/compras/compras_cerdos",
        parentId: 29,
      },
      {
        id: 35,
        label: "menuitems.compras.list.credito",
        link: "/compras/credito",
        parentId: 28,
      },
      {
        id: 23423,
        label: "menuitems.compras.list.credito_cerdos",
        link: "/compras/credito_cerdos",
        parentId: 28,
      },
    ],
  },
  // Ventas
  {
    id: 2000,
    label: "menuitems.ventas-menu.principal",
    icon: "bx bx-shopping-bag",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.ventas-menu.badge",
    // },
    subItems: [
      {
        id: 2001,
        label: "menuitems.ventas-menu.list.clientes",
        link: "/ventas/cliente",
        parentId: 2000,
      },
   
      {
        id: 2006,
        label: "menuitems.ventas-menu.list.ventas",
        link: "/ventas/venta",
        parentId: 2000,
      },
      {
        id: 2007,
        label: "menuitems.ventas-menu.list.creditos",
        link: "/ventas/creditos-venta",
        parentId: 2000,
      },
     
    ],
  },
  {
    id: 21,
    label: "menuitems.administracion.text",
    icon: "bx-cog",
    subItems: [
      {
        id: 22,
        label: "menuitems.administracion.list.empleados",
        link: "/administracion/empleados",
        parentId: 18,
      },
    
      {
        id: 25,
        label: "menuitems.administracion.list.usuarios",
        link: "/administracion/usuarios",
        parentId: 21,
      },
      {
        id: 25,
        label: "menuitems.administracion.list.reportes",
        link: "/administracion/reportes",
        parentId: 1001
    },
    ],
  },
] : usuario.role == 2 ? [
  {
    id: 1,
    label: "menuitems.menu.text",
    isTitle: true,
  },
  {
    id: 2,
    label: "menuitems.dashboards.text",
    icon: "bx-home-circle",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.dashboards.badge",
    // },
    subItems: [
      {
        id: 3,
        label: "menuitems.dashboards.list.principal",
        link: "/",
        parentId: 2,
      },
    ],
  },
  {
    id: 7,
    isLayout: true,
  },
  {
    id: 8,
    label: "menuitems.apps.text",
    isTitle: true,
  },

      // Asignacion de alimentos
   {
    id: 1000,
    label: "menuitems.alimento.text",
    icon: "bx bxl-dropbox",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.alimento.badge",
    // },
    subItems: [
      {
        id: 1001,
        label: "menuitems.alimento.list.alimento",
        link: "/alimento/AsignacionAlimento",
        parentId: 1000
      }, 
      {
        id: 1002,
        label: "menuitems.alimento.list.listado_lotes_alimento",
        link: "/alimento/listado_lotes_alimento",
        parentId: 1000
      }, 
   
    ],
  },
  // Ventas
  {
    id: 2000,
    label: "menuitems.ventas-menu.principal",
    icon: "bx bx-shopping-bag",
    // badge: {
    //   variant: "dark",
    //   text: "menuitems.ventas-menu.badge",
    // },
    subItems: [
      {
        id: 2001,
        label: "menuitems.ventas-menu.list.clientes",
        link: "/ventas/cliente",
        parentId: 2000,
      },
   
      {
        id: 2006,
        label: "menuitems.ventas-menu.list.ventas",
        link: "/ventas/venta",
        parentId: 2000,
      },
     
    ],
  },
] :
  usuario.role == 3 ? [
    {
      id: 1,
      label: "menuitems.menu.text",
      isTitle: true,
    },
    {
      id: 2,
      label: "menuitems.dashboards.text",
      icon: "bx-home-circle",
      // badge: {
      //   variant: "dark",
      //   text: "menuitems.dashboards.badge",
      // },
      subItems: [
        {
          id: 3,
          label: "menuitems.dashboards.list.principal",
          link: "/",
          parentId: 2,
        },
      ],
    },
    {
      id: 7,
      isLayout: true,
    },
    {
      id: 8,
      label: "menuitems.apps.text",
      isTitle: true,
    },
      // CERDOS
      {
        id: 400,
        label: "menuitems.cerdos.text",
        icon: "bx-store",
    
        subItems: [
          {
            id: 17,
            label: "menuitems.cerdos.list.lotes",
            link: "/cerdos/lotes",
            parentId: 400
          }, 
          {
            id: 18,
            label: "menuitems.cerdos.list.asignacion_corrales",
            link: "/cerdos/asignacion_corrales/:page_a/:lote_a",
            parentId: 400
          }, 
    
        ],
      },
      // Ciclo reproductivo
      {
        id: 1403,
        label: "menuitems.ciclo-reproductivo.text",
        icon: "bx-sync",
        
        subItems: [
        
          {
            id: 19,
            label: "menuitems.cerdos.list.inseminacion",
            link: "/cerdos/inseminacion",
            parentId: 400
          }, 
          {
            id: 43453,
            label: "menuitems.cerdos.list.traslado",
            link: "/cerdos/traslado",
            parentId: 400
          }, 
    
        ],
      },
    // Ventas
    {
      id: 2000,
      label: "menuitems.ventas-menu.principal",
      icon: "bx bx-shopping-bag",
      // badge: {
      //   variant: "dark",
      //   text: "menuitems.ventas-menu.badge",
      // },
      subItems: [
        {
          id: 2001,
          label: "menuitems.ventas-menu.list.clientes",
          link: "/ventas/cliente",
          parentId: 2000,
        },
     
        {
          id: 2006,
          label: "menuitems.ventas-menu.list.ventas",
          link: "/ventas/venta",
          parentId: 2000,
        },
       
      ],
    },
  ]:
  usuario.role == 4 ? [
    {
      id: 1,
      label: "menuitems.menu.text",
      isTitle: true,
    },
    {
      id: 2,
      label: "menuitems.dashboards.text",
      icon: "bx-home-circle",
      // badge: {
      //   variant: "dark",
      //   text: "menuitems.dashboards.badge",
      // },
      subItems: [
        {
          id: 3,
          label: "menuitems.dashboards.list.principal",
          link: "/",
          parentId: 2,
        },
      ],
    },
    {
      id: 7,
      isLayout: true,
    },
    {
      id: 8,
      label: "menuitems.apps.text",
      isTitle: true,
    },
  
     // Productos
     {
      id: 122,
      label: "menuitems.productos.text",
      icon: "bx bxl-dropbox",
      
      subItems: [
        {
          id: 15,
          label: "menuitems.inventario.list.concentrado",
          link: "/inventario/concentrado",
          parentId: 12
        }, 
        {
          id: 15,
          label: "menuitems.inventario.list.medicina",
          link: "/inventario/medicina",
          parentId: 12
        }, 
      ],
    },
      // CERDOS
      {
        id: 400,
        label: "menuitems.cerdos.text",
        icon: "bx-store",
    
        subItems: [
          {
            id: 15,
            label: "menuitems.cerdos.list.tipo_animal",
            link: "/tipo_animal/tipo_animal",
            parentId: 400
          }, 
          {
            id: 16,
            label: "menuitems.cerdos.list.cerdos",
            link: "/cerdos/cerdos",
            parentId: 400
          }, 
          {
            id: 17,
            label: "menuitems.cerdos.list.lotes",
            link: "/cerdos/lotes",
            parentId: 400
          }, 
          {
            id: 18,
            label: "menuitems.cerdos.list.asignacion_corrales",
            link: "/cerdos/asignacion_corrales/:page_a/:lote_a",
            parentId: 400
          }, 
    
        ],
      },
      // Ciclo reproductivo
      {
        id: 1403,
        label: "menuitems.ciclo-reproductivo.text",
        icon: "bx-sync",
        
        subItems: [
        
          {
            id: 19,
            label: "menuitems.cerdos.list.inseminacion",
            link: "/cerdos/inseminacion",
            parentId: 400
          }, 
          {
            id: 43453,
            label: "menuitems.cerdos.list.traslado",
            link: "/cerdos/traslado",
            parentId: 400
          }, 
    
        ],
      },
        // Asignacion de alimentos
     {
      id: 1000,
      label: "menuitems.alimento.text",
      icon: "bx bxl-dropbox",
      // badge: {
      //   variant: "dark",
      //   text: "menuitems.alimento.badge",
      // },
      subItems: [
        {
          id: 1001,
          label: "menuitems.alimento.list.alimento",
          link: "/alimento/AsignacionAlimento",
          parentId: 1000
        }, 
        {
          id: 1002,
          label: "menuitems.alimento.list.listado_lotes_alimento",
          link: "/alimento/listado_lotes_alimento",
          parentId: 1000
        }, 
     
      ],
    },
    //Compras
    {
      id: 34,
      label: "menuitems.compras.principal",
      icon: "bx bx-shopping-bag",
      subItems: [
        {
          id: 35,
          label: "menuitems.compras.list.proveedor",
          link: "/compras/proveedor",
          parentId: 28,
        },
  
        {
          id: 37,
          label: "menuitems.compras.list.compras",
          link: "/compras/compras",
          parentId: 29,
        },
        {
          id: 37,
          label: "menuitems.compras.list.compras_medicina",
          link: "/compras/compras_medicina",
          parentId: 29,
        },
        {
          id: 1203,
          label: "menuitems.compras.list.compras_cerdos",
          link: "/compras/compras_cerdos",
          parentId: 29,
        },
        {
          id: 35,
          label: "menuitems.compras.list.credito",
          link: "/compras/credito",
          parentId: 28,
        },
        {
          id: 23423,
          label: "menuitems.compras.list.credito_cerdos",
          link: "/compras/credito_cerdos",
          parentId: 28,
        },
      ],
    },
    // Ventas
    {
      id: 2000,
      label: "menuitems.ventas-menu.principal",
      icon: "bx bx-shopping-bag",
      // badge: {
      //   variant: "dark",
      //   text: "menuitems.ventas-menu.badge",
      // },
      subItems: [
        {
          id: 2001,
          label: "menuitems.ventas-menu.list.clientes",
          link: "/ventas/cliente",
          parentId: 2000,
        },
     
        {
          id: 2006,
          label: "menuitems.ventas-menu.list.ventas",
          link: "/ventas/venta",
          parentId: 2000,
        },
        {
          id: 2007,
          label: "menuitems.ventas-menu.list.creditos",
          link: "/ventas/creditos-venta",
          parentId: 2000,
        },
       
      ],
    },
    
  ] 
  
  : [];

